import { applyMiddleware, createStore } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import { createReduxHistoryContext } from "redux-first-history"
import { createLogger } from "redux-logger"
import createSagaMiddleware from "redux-saga"
import thunk from "redux-thunk"

import config from "../core/config"
import history from "../core/history"
import notificationMiddleware from "./middlewares/notifications"
import promiseMiddleware from "./middlewares/promiseMiddleware"
import rootReducer from "./reducers"
import sagas from "./sagas"

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history,
  })

export function getReduxHistory(store) {
  return createReduxHistory(store)
}

/*
 * @param {Object} initial state to bootstrap our stores with for server-side rendering
 */
export default function configureStore(initialState) {
  // Installs hooks that always keep react-router and redux
  // store in sync
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [
    thunk,
    promiseMiddleware,
    notificationMiddleware,
    sagaMiddleware,
    routerMiddleware,
  ]

  if (config.env !== "production") {
    middleware.push(
      createLogger({
        collapsed: true,
      })
    )
  }

  const store = createStore(
    rootReducer(routerReducer),
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
  )

  sagaMiddleware.run(sagas)

  return store
}
